import _ from "lodash"
import defaultMessages from "../../i18n/default.messages"

let messages = {
    messages: {
        'es-MX': {
            moduleTitle: 'Avisos',
            tblTitle: 'Lista de avisos',
            tblbutton: 'Nuevo aviso',
            mdlSave: 'Aceptar',
            mdlCancel: 'Cancelar',
            lblEdit: "Editar",
            lblDelete: "Eliminar",

            headerSearch: 'Buscar',
            headerTitle: "Título",
            headerName: "Mensaje",
            headerType: "Tipo",
            headerAction: 'Acciones',
            headerStatus: "Enviado",

            lbltittle: "Título del aviso",
            lblName: "Mensaje",
            lblType: "Tipo de aviso",

            ruleTitle: "El título no puede exceder los 15 caracteres",
            ruleName: "El mensaje no puede exceder los 30 caracteres",
            lblValidation1: "Debes de seleccionar el tipo de aviso de forma obligatoria",
            lblValidation2: "El aviso debe de tener un título de forma obligatoria",
            lblValidation3: "El aviso debe de tener un mensaje de forma obligatoria",

            lbldelete1: 'Estás apunto de eliminar el atributo',
            lbldelete2: 'Estas Seguro?',

            lblResendNotification: 'Reenviar la notificación?',

            lblCreateError: 'Error al crear el aviso'

        },
        en: {
            moduleTitle: 'Notices',
            tblTitle: 'Notice list',
            tblbutton: 'New notification',
            mdlSave: 'Accept',
            mdlCancel: 'Cancel',
            lblEdit: "Edit",
            lblDelete: "Remove",

            headerSearch: 'Search',
            headerTitle: "Title",
            headerName: "Message",
            headerType: "Type",
            headerAction: 'Actions',
            headerStatus: "Sent",

            lbltittle: "Notice title",
            lblName: "Message",
            lblType: "Notice type",

            ruleTitle: "The title cannot exceed 15 characters",
            ruleName: "The message cannot exceed 30 characters",
            lblValidation1: "You must select the type of notice in a mandatory way",
            lblValidation2: "The notice must have a mandatory title",
            lblValidation3: "El aviso debe de tener un mensaje de forma obligatoria",

            lbldelete1: 'You are about to remove the attribute',
            lbldelete2: 'Are you sure?',

            lblResendNotification: 'Resend notification?',

            lblCreateError: 'Notification error'

        }
    }
}

export default _.merge(messages, defaultMessages)